import { call, put } from 'redux-saga/effects';
import GetCalendarEventsActions from '../redux/GetCalendarEventsRedux';
import { api } from './api';


export function* getCalendarEvents(action: any): Generator<any, void, any> {
  // const { data } = action
  const { navigate } = action;
  const response = yield call(api.getCalendarEvents);

  // success?
  if (response.ok) {
    // You might need to change the response here - do this with a 'transform',
    // located in ../Transforms/. Otherwise, just pass the data back from the api.
    yield put(GetCalendarEventsActions.getCalendarEventsSuccess(response.data));
  } else {
    if (response.status === 401 && navigate) {
      // redirect to tutorial page
      navigate('/tutorial');
    }
    yield put(GetCalendarEventsActions.getCalendarEventsFailure());
  }
}